export default __webpack_public_path__ + "static/media/unauthorizedaccess.28b1fcb7.png";